<template>
  <div class="yht-backStage-home">
    <div class="yht-backStage-home-header flex">
      <div
        v-for="item in totalList"
        :key="item.id"
        :class="'yht-backStage-home-header_' + item.id"
        class="yht-backStage-home-header_item">
        <div class="yht-backStage-home-header_box">
          <div class="yht-backStage-home-header_name" v-text="item.name"></div>
          <div class="yht-backStage-home-header_total" v-text="item.total"></div>
        </div>
      </div>
    </div>
    <div class="yht-backStage-home-content">
      <div class="yht-backStage-home-content_box">
        <div class="yht-backStage-home-content_name mb30">本月新增互联网用户</div>
        <div class="yht-backStage-home_table">
          <el-table
            v-loading="loadingUser"
            ref="table"
            height="100%"
            tooltip-effect="light"
            :data="userList">
            <el-table-column label="" width="20" key="1"></el-table-column>
            <el-table-column label="序号" width="80" type="index" key="2">
            </el-table-column>
            <el-table-column prop="name" label="用户" key="3">
              <span slot-scope="scope" :title="scope.row.name">{{scope.row.name}}</span>
            </el-table-column>
            <el-table-column prop="creattime" label="注册时间" key="4">
              <span slot-scope="scope" :title="scope.row.creattime.slice(0, 10)">{{scope.row.creattime.slice(0, 10)}}</span>
            </el-table-column>
            <el-table-column prop="userKindStr" label="用户组" key="5">
              <span slot-scope="scope" :title="scope.row.userKindStr">{{scope.row.userKindStr}}</span>
            </el-table-column>
            <template slot="empty">
              <span class="mt10" style="display:block;font-size: 12px;color: #666666;">暂无查询数据</span>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'home',
  data () {
    return {
      loadingUser: false,
      totalList: [
        {
          name: '精品文物',
          id: 'jpww',
          total: 0
        },
        {
          name: '专题研究',
          id: 'ztyj',
          total: 0
        },
        {
          name: '系统用户',
          id: 'xtyh',
          total: 0
        }
      ],
      // 待审核用户列表
      userList: []
    }
  },
  props: {
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // 获取精品文物总数
      this.getJpwwTotal()
      // 获取专题研究总数
      this.getZtyjTotal()
      // 获取系统用户总数
      this.getXtylTotal()
      // 获取待审核用户列表
      this.getNewUser()
    },

    // 获取精品文物总数
    getJpwwTotal () {
      const self = this
      axios.get('/yuhuamenhu/collect/getMHCollectionNumber').then(json => {
        if (json.data.code === 200) {
          self.totalList[0].total = json.data.data && json.data.data.number ? json.data.data.number : 0
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取专题研究总数
    getZtyjTotal () {
      const self = this
      axios.get('/yuhuamenhu/special/getSpecialNum').then(json => {
        if (json.data.code === 200) {
          self.totalList[1].total = json.data.data && json.data.data.number ? json.data.data.number : 0
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取系统用户总数
    getXtylTotal () {
      const self = this
      axios.get('/yuhuamenhu/user/getSystemUserNum').then(json => {
        if (json.data.code === 200) {
          self.totalList[2].total = json.data.data ? json.data.data : 0
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 获取待审核用户列表
    getNewUser () {
      const self = this
      self.loadingUser = true
      axios.get('/yuhuamenhu/user/getNewUser').then(json => {
        if (json.data.code === 200) {
          self.userList = json.data.data
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingUser = false
      })
    }
  }
}
</script>

<style>
  .yht-backStage-home {
    width: 100%;
    height: 100%;
  }

  .yht-backStage-home-header {
    margin-bottom: 30px;
  }

  .yht-backStage-home-header_item {
    position: relative;
    padding-left: 90px;
    margin-right: 30px;
    width: calc(33.4% - 20px);
    height: 120px;
    border-radius: 10px;
    font-weight: bold;
    color: #333;
    background: #fff;
    box-shadow: 0 4px 30px 8px rgba(0, 0, 0, 0.06);
  }

  .yht-backStage-home-header_item:last-child {
    margin-right: 0;
  }

  .yht-backStage-home-header_item::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 30px;
    transform: translate(0, -50%);
    width: 40px;
    height: 40px;
  }

  .yht-backStage-home-header_jpww::before {
    background: url("../images/jpww_active.png");
    background-size: 100% 100%;
  }

  .yht-backStage-home-header_ztyj::before {
    background: url("../images/ztyj_active.png");
    background-size: 100% 100%;
  }

  .yht-backStage-home-header_xtyh::before {
    background: url("../images/xtyh.png");
    background-size: 100% 100%;
  }

  .yht-backStage-home-header_box {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }

  .yht-backStage-home-header_name {
    margin-bottom: 15px;
    width: 100%;
    font-size: 20px;
  }

  .yht-backStage-home-header_total {
    width: 100%;
    font-size: 28px;
  }

  .yht-backStage-home-content {
    display: flex;
    padding-bottom: 60px;
    width: 100%;
    height: calc(100% - 150px);
  }

  .yht-backStage-home-content_box {
    position: relative;
    padding: 30px;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: #FFFFFF;
    box-shadow: 0 4px 30px 8px rgba(0, 0, 0, 0.06);
  }

  .yht-backStage-home-content_name {
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }

  .yht-backStage-home_table {
    height: calc(100% - 61px);
  }
</style>
